import React, { useEffect, useState } from "react";
import appApi from "../../assets/utils/AppApi";
import HeroCarousel from "./HeroCarousel";

export default function DesktopSlideshow() {
  const [slides, setSlides] = useState([]);
  const [status, setStatus] = useState("loading");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setStatus("loading");
    appApi.get("/desktop-slides/published", { signal: controller.signal }).then(({ data }) => {
      if (controller.signal.aborted) return;
      if (!Array.isArray(data)) throw new Error("Invalid slides response");
      setSlides(data.filter(slide => typeof slide.image === "string" && slide.image.trim()));
      setStatus("ready");
    }).catch(() => { if (!controller.signal.aborted) setStatus("error"); });
    return () => controller.abort();
  }, [attempt]);
  if (status === "loading") return <div role="status" style={{ padding: 32 }}>در حال دریافت اسلایدها…</div>;
  if (status === "error") return <div role="status" style={{ padding: 32 }}>دریافت اسلایدها ممکن نشد. <button onClick={() => setAttempt(value => value + 1)}>تلاش دوباره</button></div>;
  return <HeroCarousel slides={slides} />;
}
